// extracted by mini-css-extract-plugin
export default {"about-header":"About_about-header__ffrVZ","title":"About_title__mn-Vz","subtitle":"About_subtitle__l2NWs","about-main":"About_about-main__Zs02v"};